module.exports = __webpack_public_path__ + "static/leaf-anim-ba4c2c0357f32fd99ca6740a7f8cc28e.png";